export const VERBAL_TOPICS = [
    { title: "Doplňování do vět", desc: "Slovní zásoba a gramatický cit (30-45s/úloha)" },
    { title: "Vztahy mezi slovy (Analogie)", desc: "Logické vztahy mezi pojmy (30-45s/úloha)" },
    { title: "Synonyma a antonyma", desc: "Význam slov v kontextu (45-60s/úloha)" },
    { title: "Krátké texty", desc: "Pochopení hlavní myšlenky (60-90s/úloha)" },
    { title: "Dlouhé texty", desc: "Detailní analýza, Fact-Free Zone (2-4min/úloha)" },
    { title: "Porovnávání textů", desc: "Komparace myšlenek (4-5min/úloha)" },
    { title: "Co není v souladu", desc: "Odhalení nesrovnalostí v textu (60-90s/úloha)" }
];

export const ANALYTICAL_TOPICS = [
    { title: "Grafy a tabulky", desc: "Interpretace dat z více zdrojů" },
    { title: "Porovnávání hodnot", desc: "Algebraické vztahy a nerovnice" },
    { title: "Dostačující tvrzení", desc: "Logická úplnost informací" },
    { title: "Slovní úlohy", desc: "Převod textu na matematické rovnice" },
    { title: "Matematizace", desc: "Práce s abstraktními výrazy" },
    { title: "Vynechávky (Substituce)", desc: "Algebraická úprava výrazů" },
    { title: "Smyšlené operace", desc: "Práce s novými matematickými operacemi" },
    { title: "Funkce", desc: "Funkční závislosti a hodnoty" },
    { title: "Zebry (Logické úlohy)", desc: "Deduktivní logika a kombinatorika" }
];

export const getDailyChallengePrompt = () => {
    const today = new Date().toLocaleDateString('cs-CZ');
    return `Dnes je ${today}. Vygeneruj mi speciální Denní výzvu pro OSP. Vymysli 3 zbrusu nové, originální a o něco těžší úlohy (mix verbálního a analytického oddílu), které se tematicky trochu vážou k dnešnímu dni nebo aktuálnímu ročnímu období. Cílem je, abych se nenudil. Počkáme na mé odpovědi a pak je všechny najednou vyhodnotíme.`;
};

export const QUICK_DRILL_PROMPT = "Spusť rychlý drill. Dávej mi náhodné úlohy z OSP střídavě z verbálního i analytického oddílu. Jedna úloha za druhou, po mé odpovědi okamžitě vyhodnoť, zaznamenej mé skóre a přejdi na další. Žádné dlouhé úvody. Vysvětlení mi dej, pouze pokud odpovím špatně. Průběžně mi hlasi moje skóre (např. 'Máš 3/4 správně').";
